import i18n from '@/utils/i18n';
import PlusIcon from '@assets/icons/plus.svg';
import React, { useState } from 'react';
import WheyIcon from '@assets/icons/whey.svg';
import { CircledIcon } from '@/components/circled-icon';
import { createStyles } from '@/contexts/theme-context';
import { EmptyStateMinimal } from '@/components/empty-state-minimal';
import { MenuDetailComponent } from '@/components/menu/menu-detail-component';
import { MenuItem, useMenuInfoContext } from '@/contexts/menu-info-context';
import { MenuItemDetailComponent } from '@/components/menu/menu-item-detail-component';
import { SplitPageContainer } from '@/components/split-page-container';
import { TouchableOpacity, View } from 'react-native';

export const SplitMenuDetailScreen: React.FC = () => {
  const { menuItemMap } = useMenuInfoContext();
  const [styles] = useStyles();

  const [showAddMenuItemSheet, setShowAddMenuItemSheet] = useState(false);
  const [selectedMenuItemUUID, setSelectedMenuItemUUID] = useState<
    string | null
  >(null);

  const menuItem = selectedMenuItemUUID
    ? (menuItemMap.get(selectedMenuItemUUID) as MenuItem)
    : null;

  return (
    <SplitPageContainer
      actions={[
        {
          component: (
            <TouchableOpacity onPress={() => setShowAddMenuItemSheet(true)}>
              <CircledIcon
                Icon={PlusIcon}
                iconHeight={20}
                iconWidth={20}
                size="small"
              />
            </TouchableOpacity>
          ),
        },
      ]}
      primaryComponent={
        <MenuDetailComponent
          listItemContainerStyleFn={(option) =>
            option.value === selectedMenuItemUUID
              ? styles.selectedItemContainer
              : null
          }
          onMenuItemSelect={setSelectedMenuItemUUID}
          setShowAddMenuItemSheet={setShowAddMenuItemSheet}
          showAddMenuItemSheet={showAddMenuItemSheet}
        />
      }
      title={i18n.t('menu')}
    >
      {menuItem ? (
        <MenuItemDetailComponent
          menuItem={menuItem}
          onDeleteMenuItem={() => setSelectedMenuItemUUID(null)}
        />
      ) : (
        <View style={styles.emptyState}>
          <EmptyStateMinimal
            ImageComponent={WheyIcon}
            text={i18n.t('menu_costing.empty_message')}
          />
        </View>
      )}
    </SplitPageContainer>
  );
};

const useStyles = createStyles((theme) => ({
  emptyState: {
    flex: 1,
  },
  selectedItemContainer: {
    backgroundColor: theme.colors.accentLight,
  },
}));
